import * as React from 'react'

function SvgAg(props) {
	return (
		<svg viewBox="0 0 138 92" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M0 0h138v92H0z" />
			<path d="M0 0h138v36H0z" />
			<g transform="translate(69 36)">
				<g id="ag_svg__b">
					<path id="ag_svg__a" d="M-30 0L0-5.742V5.742z" fill="#fcd116" />
					<use xlinkHref="#ag_svg__a" transform="rotate(22.5)" />
					<use xlinkHref="#ag_svg__a" transform="rotate(45)" />
				</g>
				<use xlinkHref="#ag_svg__b" transform="rotate(67.5)" />
				<use xlinkHref="#ag_svg__b" transform="rotate(135)" />
			</g>
			<path fill="#0072c6" d="M0 36h138v20H0z" />
			<path d="M0 0v92h68M138 0v92H68" fill="#ce1126" />
		</svg>
	)
}

export default SvgAg
